import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export function useCoachUnread() {
  const { data } = useQuery({
    queryKey: ['coach-unread'],
    queryFn: () => api.get<{ unread: boolean }>('/api/patient/coach/unread'),
    staleTime: 60_000,
  })
  return data?.unread ?? false
}
